<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>成绩显示设置</span>
              <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
            </div>
            <div>

              <div class="rowStyle">
                <el-checkbox v-model="showPosition" @change="changeShowPositionState">显示成绩在班级中的名次</el-checkbox>
                <div style="padding-left: 30px;">说明：选中后会在查询结果中显示成绩的排名</div>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.examID = this.$route.params.id
    },
    data() {
      return {
        exam_key: -1,
        showPosition: false
      }
    },
    methods: {
      loadData() {
        let that = this

        // 注册接口
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_key: that.examID
            }
          }).then(function(response) {
            that.showSettings(response)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      changeShowPositionState() {
        console.log(this.showPosition)

        var intShowPosition = 0
        if (this.showPosition) {
          intShowPosition = 1
        } else {
          intShowPosition = 0
        }

        let that = this

        // 注册接口
        var requestUrl = '/score/web/_update_setting_show_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              show_position: intShowPosition,
              exam_key: that.examID
            }
          }).then(function(response) {
            console.log(response.data.result)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showSettings(res) {

      }
    }
  }
</script>

<style>
  .rowStyle {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/search_result_settings.vue